<template>
    <v-container fluid>
        <template>
            <v-data-table :headers="headers" :items="reportList" sort-by="calories" class="elevation-1">
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>Reports</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="viewItem(item)">
                        mdi-eye
                    </v-icon>
                    <v-icon small class="mr-2" @click="downloadItem(item)">
                        mdi-download
                    </v-icon>
                    <v-icon small @click="removeReport(item.id)">
                        mdi-delete
                    </v-icon>
                </template>
            </v-data-table>
        </template>
    </v-container>
</template>

<script>
import ProductImage from "../../components/ProductImage.vue"
import requests from "../../requests";
export default {
    name: "report-list-page",
    components: { ProductImage },
    data: () => {
        return {
            reportList: [],
            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Nome', value: 'name' },
                { text: 'Tipo', value: 'type' },
                { text: 'Data Creazione', value: 'created_at' },
                { text: 'Actions', value: 'actions', sortable: false },
            ]
        };
    },
    mounted() {
        console.log("Report List Mounted.");
        this.getReportList();
    },
    methods: {
        getReportList() {
            requests.getReportList().then((res) => {
                this.reportList = res.data;
            });
        },
        removeReport(id) {
            if (!window.confirm('Vuoi eliminare questo report?')) return false;
            requests.deleteReportList(id).then(res => {
                if (res.data.result) {
                    this.getReportList();
                }
            });
        },
        viewItem(item) {
            this.$router.push({ name: 'report1', params: { id: item.id, report: item.type } });
        },
        downloadItem(item) {
            window.document.location.href = "/api/report-pdf?id=" + item.id;
        }
    },
    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        }
    }
};
</script>
